import { ProductionFulfillmentApi, useAPIQuery } from "melco-shared-logic";

const queryKeyForLog = (logId: string) => {
  return ["log", logId];
};

export const useLog = (logId: string) => {
  return useAPIQuery(
    ProductionFulfillmentApi,
    queryKeyForLog(logId),
    async (api) => api.productionFulfillmentRunsGetRun({ id: logId })
  );
};
